import { IHrDepartmentActions, HrDepartmentContext } from './actions.types';
import { IHrDepartmentData } from '@/models';

export const actions: IHrDepartmentActions = {
  fetchHrDepartments(context: HrDepartmentContext): Promise<void> {
    const promise = this.$services.hrDepartment.fetchHrDepartments();
    context.commit('SET_LAST_PROMISE', promise);
    return promise.then((hrDepartments: IHrDepartmentData[]) => {
      if (promise == context.state.lastPromise) {
        context.commit('SET_HR_DEPARTMENTS', hrDepartments);
        context.commit('SET_LAST_PROMISE', null);
      }
    });
  },

  fetchHrDepartment(
    context: HrDepartmentContext,
    payload: number
  ): Promise<void> {
    return this.$services.hrDepartment
      .fetchHrDepartment(payload)
      .then((hrDepartment: IHrDepartmentData) => {
        const index = context.state.hrDepartments.findIndex(
          (v: IHrDepartmentData) => v.id === hrDepartment.id
        );
        if (index === -1) {
          context.commit('ADD_HR_DEPARTMENT', hrDepartment);
        } else {
          context.commit('UPDATE_HR_DEPARTMENT', hrDepartment);
        }
      });
  },

  createHrDepartment(
    context: HrDepartmentContext,
    payload: IHrDepartmentData
  ): Promise<void> {
    return this.$services.hrDepartment
      .createHrDepartment(payload)
      .then((hrDepartment: IHrDepartmentData) =>
        context.commit('ADD_HR_DEPARTMENT', hrDepartment)
      );
  },

  updateHrDepartment(
    context: HrDepartmentContext,
    payload: IHrDepartmentData
  ): Promise<void> {
    return this.$services.hrDepartment
      .updateHrDepartment(payload)
      .then((hrDepartment: IHrDepartmentData) => {
        const index = context.state.hrDepartments.findIndex(
          (v: IHrDepartmentData) => v.id === hrDepartment.id
        );
        if (index === -1) {
          context.commit('ADD_HR_DEPARTMENT', hrDepartment);
        } else {
          context.commit('UPDATE_HR_DEPARTMENT', hrDepartment);
        }
      });
  },

  deleteHrDepartment(
    context: HrDepartmentContext,
    payload: number
  ): Promise<void> {
    return this.$services.hrDepartment.deleteHrDepartment(payload).then(() => {
      context.commit('REMOVE_HR_DEPARTMENT', payload);
    });
  }
};
